
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";


const firebaseConfig = {
    apiKey: "AIzaSyCd-vCnDJXtjsqoFIy525DCEGg7tbvguCM",
    authDomain: "winners-ai-473119.firebaseapp.com",
    projectId: "winners-ai-473119",
    storageBucket: "winners-ai-473119.firebasestorage.app",
    messagingSenderId: "712108985873",
    appId: "1:712108985873:web:944314ab73cc9a42422bb0",
    measurementId: "G-ZRWZPQLQZN"
};

const firebaseApp = initializeApp(firebaseConfig);

const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);

export { auth, db };